var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/geofence';
import http from 'app/services/http';
export const geofenceReducer = (state = {
    typeItems: [],
    groupItems: [],
    groupSearchValue: '',
    groupSelectedItem: null,
}, action) => {
    switch (action.type) {
        case 'GEOFENCE_GROUP_SET_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: items });
        }
        case 'GEOFENCE_GROUP_SET_SELECTED_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSelectedItem: data });
        }
        case 'GEOFENCE_GROUP_SET_SEARCH_VALUE': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSearchValue: value });
        }
        case 'GEOFENCE_GROUP_ADD_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: [...state.groupItems, data] });
        }
        case 'GEOFENCE_GROUP_UPDATE_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSelectedItem: data, groupItems: state.groupItems.map((value) => {
                    if (value.id !== state.groupSelectedItem.id) {
                        return value;
                    }
                    return data;
                }) });
        }
        case 'GEOFENCE_GROUP_DELETE_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: state.groupItems.filter((item) => item.id !== id), groupSelectedItem: null });
        }
        case 'GEOFENCE_SET_TYPE_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { typeItems: items });
        }
        default:
            return state;
    }
};
export function geofenceGroupLoad() {
    return function geofenceGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/geofence/group`);
            return dispatch(actions.setGroupItems(data));
        });
    };
}
export function geofenceGroupCreate(params) {
    return function geofenceCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/geofence/group', params);
            return dispatch(actions.addGroupItem(data));
        });
    };
}
export function geofenceGroupUpdate(id, params) {
    return function geofenceUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/geofence/group/${id}`, params);
            return dispatch(actions.updateGroupItem(data));
        });
    };
}
export function geofenceGroupDelete(id) {
    return function geofenceDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/geofence/group/${id}`);
            return dispatch(actions.deleteGroupItem(id));
        });
    };
}
export function geofenceGroupFormLoad() {
    return __awaiter(this, void 0, void 0, function* () {
        return http
            .get('/geofence/group')
            .then((response) => response.data)
            .then((response) => {
            return response;
        })
            .catch();
    });
}
export function geofenceTypeLoad() {
    return function geofenceTypeLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/geofence/type');
            return dispatch(actions.setTypeItems(data));
        });
    };
}
export default geofenceReducer;
